/* eslint-disable react/no-array-index-key */
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import DrawerLoader from '../utils/DrawerLoader';
import { closeDrawer, cancelReturnVoucher } from '../vouchersActions';
import ItemsForm from './ItemsForm';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 60px;
`;

const useStyles = makeStyles(() => ({
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  }
}));

const VoucherDrawer = ({
  isOpen,
  dispatchCloseDrawer,
  currentReturnVoucher,
  loading,
  dispatchCancelReturnVoucher,
  submitForm
}) => {
  const classes = useStyles();
  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      onOpen={() => null}
      onClose={() => {
        dispatchCloseDrawer();
      }}
      open={isOpen}
    >
      {loading ? (
        <DrawerLoader />
      ) : (
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <h1>
            Référence commande :{' '}
            {currentReturnVoucher.command.externalReference}
          </h1>
          {!currentReturnVoucher.receivedDate ? null : (
            <h3>
              {`Reçu le ${moment(currentReturnVoucher.receivedDate).format(
                'DD/MM/YYYY'
              )}`}
            </h3>
          )}
          {!currentReturnVoucher.processedDate ? null : (
            <h3>
              {`Traité le  ${moment(currentReturnVoucher.processedDate).format(
                'DD/MM/YYYY'
              )}`}
            </h3>
          )}
          <ItemsForm />
          <ButtonContainer>
            <Button
              variant="contained"
              color="secondary"
              onClick={() =>
                dispatchCancelReturnVoucher(currentReturnVoucher.id)
              }
              disabled={!currentReturnVoucher.isCancellableBySender}
            >
              Annuler le bon de retour
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => submitForm('updateRecipientReturnVoucher')}
              disabled={!currentReturnVoucher.isUpdatable}
            >
              Mettre à jour le bon de retour
            </Button>
          </ButtonContainer>
        </div>
      )}
    </SwipeableDrawer>
  );
};

const mapStateToProps = state => ({
  isOpen: state.vouchers.openDrawer,
  currentReturnVoucher: state.vouchers.currentReturnVoucher,
  loading: state.vouchers.loadingCurrentReturnVoucher,
  initialValues: {
    items: state.vouchers.currentReturnVoucher.items
  }
});

const mapDispatchToProps = dispatch => ({
  dispatchCloseDrawer: () => dispatch(closeDrawer()),
  dispatchCancelReturnVoucher: returnVoucherId =>
    dispatch(cancelReturnVoucher(returnVoucherId)),
  submitForm: formName => dispatch(submit(formName))
});

VoucherDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dispatchCloseDrawer: PropTypes.func.isRequired,
  currentReturnVoucher: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchCancelReturnVoucher: PropTypes.func,
  submitForm: PropTypes.func
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VoucherDrawer);
